import { ElDialog, ElIcon, ElCarousel, ElCarouselItem, ElLink } from "element-plus";
import baseApp from './../innerAPP';
import './../css/home.css';
import App from './App';
const vm = baseApp(App);
vm.use(ElDialog).use(ElIcon).use(ElCarousel).use(ElCarouselItem).use(ElLink);
vm.mount('#app');